"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UiComponents = require("./components/UiComponents");

var _useHeaderMenu = require("./useHeaderMenu");

var _MenuPrincipal = require("./components/MenuPrincipal");

var _SubMenu = require("./components/SubMenu");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? _defineProperty({
  type: _propTypes.string,
  domain: _propTypes.string,
  activeItem: _propTypes.string,
  toggleCallback: _propTypes.func,
  className: _propTypes.string,
  component: _propTypes.string,
  showLogin: _propTypes.bool,
  children: _propTypes.element
}, "data-testid", _propTypes.string) : {};

var HeaderMenu = function HeaderMenu(_ref2) {
  var className = _ref2.className,
      _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? 'div' : _ref2$component,
      dataTestId = _ref2["data-testid"],
      children = _ref2.children,
      toggleCallback = _ref2.toggleCallback;

  var _ref3 = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref4 = _slicedToArray(_ref3, 1),
      _ref4$ = _ref4[0],
      isOpen = _ref4$.isOpen,
      isOpenSubMenu = _ref4$.isOpenSubMenu,
      isCustomType = _ref4$.isCustomType,
      fixed = _ref4$.fixed;

  (0, _react.useEffect)(function () {
    if (toggleCallback) {
      toggleCallback(isOpen);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  return (0, _core.jsx)(_UiComponents.Container, {
    fixed: fixed || isOpenSubMenu || isOpen
  }, (0, _core.jsx)(_UiComponents.Container.Main, {
    as: component,
    className: className,
    "data-testid": dataTestId,
    fixed: fixed,
    isOpen: isOpen,
    isCustomType: isCustomType
  }, (0, _core.jsx)(_MenuPrincipal.MenuPrincipal, null)), isCustomType && (0, _core.jsx)(_SubMenu.SubMenu, null, children));
};

process.env.NODE_ENV !== "production" ? HeaderMenu.propTypes = propTypes : void 0;

var HeaderMenuWithProvider = function HeaderMenuWithProvider(props) {
  return (0, _core.jsx)(_useHeaderMenu.HeaderMenuProvider, {
    type: props.type,
    domain: props.domain,
    activeItem: props.activeItem,
    showLogin: props.showLogin
  }, (0, _core.jsx)(HeaderMenu, props));
};

exports.HeaderMenu = HeaderMenuWithProvider;
process.env.NODE_ENV !== "production" ? HeaderMenuWithProvider.propTypes = propTypes : void 0;
HeaderMenuWithProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HeaderMenuWithProvider",
  "props": {
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "domain": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "activeItem": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "toggleCallback": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "component": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "showLogin": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": ""
    }
  }
};